import { render, staticRenderFns } from "./referral-info-link.vue?vue&type=template&id=3a37ff66&scoped=true"
import script from "./referral-info-link.vue?vue&type=script&lang=js"
export * from "./referral-info-link.vue?vue&type=script&lang=js"
import style0 from "./referral-info-link.vue?vue&type=style&index=0&id=3a37ff66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a37ff66",
  null
  
)

export default component.exports